<template>
  <div id="pushWeekly">
    <div class="title">积分汇总数据</div>
    <div class="search">
      <el-select
        v-model="valueWeek"
        placeholder="请选择"
        class="selectWeek"
        @change="changeWeek"
      >
        <el-option
          v-for="item in optionWeek"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="valueMonth"
        placeholder="请选择"
        class="selectMonth"
        @change="changeMonth"
      >
        <el-option
          v-for="item in optionMonth"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="channel" label="积分来源" align="center">
        </el-table-column>
        <el-table-column prop="point" label="产生积分" align="center">
        </el-table-column>
        <el-table-column prop="cost" label="产生费用/元" align="center">
        </el-table-column>
      </el-table>
    </div>
    <div class="menu" style="color: red;font-size: 14px;margin-top: 10px;" v-if="valueMonth == 2 || valueMonth == 3">
      注：汇总数据从2024年11月中旬更新，雷士学堂、知识资讯圈11月月报和2024年报暂汇总的是累计值。
    </div>
  </div>
</template>

<script>
import apiCar from "@/apis/car";
import apiLogin from "@/apis";
import api from "@/apis/medal";
import { getToken } from "@/utils/cookie";
export default {
  data() {
    return {
      valueWeek: 0,
      valueMonth: 1,
      optionWeek: [],
      optionMonth: [
        {
          value: 1,
          label: "周报",
        },
        {
          value: 2,
          label: "月报",
        },
        {
          value: 3,
          label: "年报",
        },
      ],
      tableData: [],
    };
  },
  mounted() {
    const { type } = this.$route.query;
    if (type) {
      this.valueMonth = Number(type);
    }
    let token = window.sessionStorage.hrToken;
    let hrToken = getToken();
    //获取hrToken
    if (token) {
      this.empno = hrToken;
      this.getSelect();
    } else {
      this.$bus.$on("processToken", (res) => {
        this.empno = res;
        console.log(res);
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.getSelect();
        });
      });
    }
  },
  methods: {
    //获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        // console.log("username:" + new Date(), username);
        if (username) {
          let thisname = username;

          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            // console.log(data);
            const info = data.data;

            localStorage.setItem("salaryPhone", info.mobileNo);
            localStorage.setItem("salaryInfo", JSON.stringify(info));

            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    //获取表格数据
    getTable() {
      const params = {
        startDate: this.startDate,
        endDate: this.endDate,
        username: this.empno,
      };
      api.pushQueryList(params).then((res) => {
        if (res.code == 200) {
          // const list = res.data;
          // this.tableData = list.filter((item) => {
          //   return item.channel != "荣誉体系";
          // })
          this.tableData = res.data;
        }
      });
    },
    //获取时间
    getSelect() {
      apiCar.queryDateRange({ dateType: this.valueMonth }).then((data) => {
        if (data.code == 200) {
          const res = data.data;
          this.optionWeek = res;
          this.optionWeek.forEach((item, i) => {
            item.value = i;
            item.label = item.startTime + "到" + item.endTime;
          });
          if (this.valueMonth == 3) {
            this.startDate = this.optionWeek[0].startTime;
            this.endDate = this.optionWeek[0].endTime;
            this.valueWeek = 0;
          } else {
            this.startDate = this.optionWeek[1].startTime;
            this.endDate = this.optionWeek[1].endTime;
            this.valueWeek = 1;
          }
          this.getTable();
        }
      });
    },
    //改变时间
    changeMonth(val) {
      if (val == 1) {
        this.week = "周";
      } else if (val == 2) {
        this.week = "月";
      } else {
        this.week = "年";
      }
      this.getSelect();
    },
    //改变周报
    changeWeek(val) {
      const index = this.optionWeek.find((item) => item.value == val);
      this.startDate = index.startTime;
      this.endDate = index.endTime;
      this.getTable();
    },
    changeDate() {},
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  #pushWeekly {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  #pushWeekly {
    width: 306px * $zoom;
  }
}
#pushWeekly {
  font-size: 16px * $zoom;
  position: relative;
  background: #fff;
  height: 100vh;
  padding: 0 20px;
  .title {
    text-align: center;
    margin: 40px 0;
  }
  .search {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 32px;
    margin-bottom: 40px;
    // padding: 20px 30px;
    ::v-deep {
      .el-input__inner {
        height: 80px !important;
        border-radius: 12px !important;
        font-size: 28px;
      }
      .selectWeek {
        width: 60% !important;
      }
      .selectMonth {
        width: 22% !important;
      }
    }
  }
  .table {
    ::v-deep {
      .el-table__cell {
        padding: 0 !important;
      }
      .cell {
        height: 80px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      tbody {
        // tbody下的最后一个tr
        tr:last-child {
          background: rgb(152, 204, 181);
        }
      }
    }
  }
}
</style>
